<template lang="html">
  <div>
    <br>
    <v-layout align-center justify-center>
      <v-flex xs12 lg8>

        <!-- Objetivos -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Objetivos"
            :value="this.projetoPesquisa.objetivos ? this.projetoPesquisa.objetivos : '-'" 
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Metodologia -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Metodologia"
            :value="this.projetoPesquisa.metodologia ? this.projetoPesquisa.metodologia : '-'"  
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Principal Objetivo de Desenvolvimento Sustentável -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Principal Objetivo de Desenvolvimento Sustentável" 
            :value="this.projetoPesquisa.principalODS ? this.projetoPesquisa.principalODS.descricao : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Objetivo de Desenvolvimento Sustentável Afim -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Objetivo de Desenvolvimento Sustentável Afim" 
            :value="this.projetoPesquisa.afimODS? this.projetoPesquisa.afimODS.descricao : '-'"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <!-- Resultados esperados -->
        <v-layout row>
          <v-flex xs12>
            <c-readonly-field 
            label="Resultados esperados"
            :value="this.projetoPesquisa.resultadosEsperados ? this.projetoPesquisa.resultadosEsperados : '-'"  
            align="justify"
            ></c-readonly-field>
          </v-flex>
        </v-layout>

        <br>

      </v-flex>
    </v-layout>

    <v-divider></v-divider>

    <v-card-actions>

      <!-- Botão "Voltar" -->
      <v-btn color="primary" @click="toVoltar()">Voltar</v-btn>

      <v-spacer></v-spacer>

      <!-- Botão "Editar" -->
      <v-btn color="primary" @click="toEditar()" v-if="administradorPRPPG || projetoPesquisa.coordenador">Editar</v-btn>

      <!-- Botão "Avançar" -->
      <v-btn color="primary" @click="toAvancar()">Avançar</v-btn>

    </v-card-actions>

  </div>
</template>

<script>
import ReadonlyField from '@/components/c-readonly-field'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjetoPesquisa', 'projetoPesquisa'],
  data: () => ({
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'administradorPRPPG'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),

    // Edita a aba "Detalhamento".
    toEditar: function () {
      this.$router.push({ name: 'EditarProjetoPesquisaDetalhamento', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Voltar para a aba anterior.
    toVoltar: function () {
      this.$router.push({ name: 'ProjetoPesquisaInformacoesBasicas', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    },

    // Avançar para a próxima aba.
    toAvancar: function () {
      this.$router.push({ name: 'ProjetoPesquisaInstituicoes', params: {idProjetoPesquisa: this.idProjetoPesquisa} })
    }
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-readonly-field': ReadonlyField
  }
}
</script>




// WEBPACK FOOTER //
// detalhamento.vue?bdbcdca4